// React and Context
import { useEffect, useState, useContext, useRef } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import { useFormDebounce } from 'hooks/useFormDebounce'

//Material and Icons
import { Box, Grid, Typography } from '@mui/material'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

// Additional Components
import { OnboardingTile } from './OnboardingTile'

const OnboardingYesNo = ({
  id,
  onChange = (e) => console.log(e),
  preHeader,
  header,
  subHeader,
  setDefaultValues = undefined,
  handleNext,
}) => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const { updateIntakeStateAndSubmit } = useFormDebounce()
  const [tileValue, setTileValue] = useState(intakeState?.[id])

  const userInitiatedChange = useRef(false)

  const toggleTileValue = (name) => {
    //if a tile is re-selected process the same way
    if (tileValue === name) {
      onChange(name)
      if (typeof name === 'boolean') {
        updateIntakeStateAtKey({ [id]: name })
        handleNext?.()
      }
      return
    }
    setTileValue(name)
    userInitiatedChange.current = true
  }

  useEffect(() => {
    onChange(tileValue)
    if (typeof tileValue != 'boolean') return
    updateIntakeStateAtKey({ [id]: tileValue })
  }, [tileValue])

  useEffect(() => {
    if (
      userInitiatedChange.current &&
      intakeState?.[id] === tileValue &&
      typeof handleNext === 'function'
    ) {
      handleNext()
      userInitiatedChange.current = false
    }
  }, [intakeState?.[id]])

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box>
        <Typography variant="subtitle1" fontSize={{ xs: '16px', sm: '20px' }}>
          {preHeader || ''}
        </Typography>
      </Box>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          {header || ''}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        sx={{ lineHeight: '1.2' }}
        fontSize={{ xs: '16px', sm: '20px' }}
      >
        {subHeader || ''}
      </Typography>
      <Box component="div" pt={3}>
        <Grid container spacing={1} justifyContent="center" mb={3}>
          <Grid item xs={6}>
            <OnboardingTile
              label="Yes"
              icon={<CheckRoundedIcon />}
              active={tileValue === true}
              onClick={() => toggleTileValue(true)}
              iconClassName="yesIcon"
            ></OnboardingTile>
          </Grid>
          <Grid item xs={6}>
            <OnboardingTile
              label="No"
              icon={<CloseRoundedIcon />}
              active={tileValue === false}
              onClick={() => toggleTileValue(false)}
              iconClassName="noIcon"
            ></OnboardingTile>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default OnboardingYesNo
